<app-header></app-header>
<ion-content data-cy="catalog-content">
  <app-page-title-banner
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    [pageTitle]="'i18n.search.searchCatalogPage.browseProducts' | translate"
    [backgroundImageStyle]="backgroundImageStyle"
    [overlayGradient]="overlayGradient"
    [showEllipsis]="false"
  ></app-page-title-banner>

  <section class="search-catalog-container">
    <section class="search-catalog-categories">
      <section class="category-header">
        <ion-icon
          *ngIf="catalogConfig.subcategory.view"
          data-cy="icon-return-category-view"
          (click)="returnToCategoryView()"
          name="arrow-back-outline"
        ></ion-icon>
        <h3 data-cy="icon-return-category-view">
          {{ catalogConfig.messages.category.value}}
        </h3>
        <span
          (click)="viewCategoryProducts(catalogConfig.selectedCategory)"
          [attr.data-cy]="'select-category-'+catalogConfig.selectedCategory"
          *ngIf="catalogConfig.subcategory.view"
          >{{catalogConfig.messages.viewAll.value}}</span
        >
        <span
          (click)="viewAllProducts()"
          data-cy="view-all-products"
          *ngIf="!catalogConfig.subcategory.view"
          >{{catalogConfig.messages.viewAll.value}}</span
        >
      </section>
      <section class="category-list" data-cy="category-list">
        <section *ngIf="catalogConfig.loading else categoryView">
          <app-search-catalog-skeleton></app-search-catalog-skeleton>
        </section>
      </section>
      <section
        *ngIf="!catalogConfig.loading && !showMoreOptions && categoryList?.length > 9 && !catalogConfig.subcategory.view"
        class="view-all-toggle-section"
      >
        <ion-button
          class="usf-outline-green-button"
          data-cy="view-all-toggle-button"
          (click)="viewAllCategories()"
          >{{ 'i18n.search.searchCatalogPage.viewAll' | translate }}</ion-button
        >
      </section>
      <section
        id="mobile-view-less-section"
        class="view-all-toggle-section"
        *ngIf="!catalogConfig.loading && catalogConfig.category.viewLessButton && !catalogConfig.subcategory.view"
      >
        <ion-button
          class="usf-outline-green-button"
          data-cy="view-less-toggle-button"
          (click)="viewLessCategories()"
          >{{ 'i18n.search.searchCatalogPage.viewLess' | translate
          }}</ion-button
        >
      </section>
      <section
        *ngIf="!catalogConfig.loading && catalogConfig.subcategory.view  &&  catalogConfig.subcategory.hasMoreItems"
        class="view-all-toggle-section"
      >
        <ion-button
          class="usf-outline-green-button"
          data-cy="view-all-subcategories-toggle-button"
          (click)="viewAllSubCategories()"
          >{{ 'i18n.search.searchCatalogPage.viewAll' | translate }}</ion-button
        >
      </section>
    </section>
    <article
      class="catalog-bottom-banner"
      data-cy="catalog-bottom-banner"
    ></article>
  </section>
  <app-footer></app-footer>
</ion-content>
<ng-template #categoryView>
  <ng-container *ngIf="!catalogConfig.subcategory.view else subCategoryView">
    <ng-container
      *ngFor="let category of categoryList   | slice:0: catalogConfig.category.maxLength "
    >
      <app-product-category
        [name]="category?.description"
        [alternativeText]="category?.description"
        [imgSource]="classCategoryUri + category?.dimensionId +'.jpg'"
        (clickCategory)="viewSubcategory(category)"
      ></app-product-category>
    </ng-container>
    <app-product-category
      *ngIf="showMoreOptions"
      [name]="'i18n.deals.whileSupplies' | translate"
      [alternativeText]="'i18n.deals.whileSupplies' | translate"
      [imgSource]="whileSuppliesLastUrlImg"
      (clickCategory)="goToWhileSuppliesLast()"
    ></app-product-category>
  </ng-container>
</ng-template>
<ng-template #subCategoryView>
  <ng-container
    *ngFor="let subcategory of subcategoryList | slice:0: catalogConfig.subcategory.maxLength  "
  >
    <app-product-category
      [name]="subcategory?.description"
      [alternativeText]="subcategory?.description"
      [imgSource]="classCategoryUri + subcategory?.dimensionId +'.jpg'"
      (clickCategory)="viewCategoryProducts(subcategory)"
    ></app-product-category>
  </ng-container>
</ng-template>
